import TourPage from "@/components/TourPage";

export default function MasaiMaraRoad4Day() {
  return (
    <TourPage
      tourId="kenya/masai-mara-road-4-day"
      title="4 Days Masai Mara Road Safari"
      duration="4 Days / 3 Nights"
      price="Contact for price"
      image="/masaimaragreatmigration.png"
      description="Embark on an extended 4-day road safari to the magnificent Masai Mara National Reserve. Experience the best of African wildlife, stunning landscapes, and authentic cultural encounters."
      itinerary={[
        {
          day: 1,
          title: "Nairobi to Masai Mara",
          description: "Journey to the world-famous Masai Mara.",
          activities: [
            "Morning pickup from your Nairobi hotel",
            "Scenic drive through the Great Rift Valley",
            "Arrive at the lodge for lunch",
            "Afternoon game drive in the reserve"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Full Day Masai Mara Game Drives",
          description: "Explore the rich wildlife of Masai Mara.",
          activities: [
            "Early morning game drive",
            "Return to camp for breakfast",
            "Mid-morning game drive",
            "Afternoon game drive in different areas of the reserve"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Masai Mara Cultural Experience",
          description: "Wildlife viewing and cultural immersion.",
          activities: [
            "Morning game drive",
            "Visit to a traditional Masai village",
            "Learn about Masai culture and traditions",
            "Evening game drive"
          ],
          accommodation: "Mara Lodge or Similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Masai Mara to Nairobi",
          description: "Final wildlife viewing and return journey.",
          activities: [
            "Early morning game drive",
            "Breakfast at the lodge",
            "Drive back to Nairobi",
            "Drop-off at your hotel or airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All transportation in a safari vehicle",
        "Professional English-speaking guide",
        "All park entrance fees",
        "Full board accommodation",
        "Game drives as per itinerary",
        "Bottled water during safari",
        "Cultural visit to Masai village"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips for driver/guide",
        "Drinks and beverages",
        "Activities not mentioned in the itinerary"
      ]}
    />
  );
}
